import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { useCallback, useEffect } from "react";

export const useOnScreenFocused = (onFocus: (isFocused: boolean) => void) => {
    const navigation = useNavigation();

    useFocusEffect(
        useCallback(() => {
            onFocus(true);
        }, [onFocus]),
    );

    useEffect(() => {
        const unsubscribe = navigation.addListener("blur", () => {
            onFocus(false);
        });
        return unsubscribe;
    }, [navigation, onFocus]);
};
